import * as types from '@/constants/mutationTypes'

const state = {
  templatesList: [],
  foldersList: [],
  currentFolder: {},
  currentTemplate: {},
  draggedTemplate: {},
  templateSetting: {}
}
const getters = {
  templatesList: state => state.templatesList,
  foldersList: state => state.foldersList,
  currentFolder: state => state.currentFolder,
  currentTemplate: state => state.currentTemplate,
  draggedTemplate: state => state.draggedTemplate,
  templateSetting: state => state.templateSetting
}
const actions = {
  setTemplatesList ({commit}, data) {
    commit(types.SET_TEMPLATES_LIST, {data})
  },
  setFoldersList ({commit}, data) {
    commit(types.SET_FOLDERS_LIST, {data})
  },
  setCurrentFolder ({commit}, data) {
    commit(types.SET_CURRENT_FOLDER, {data})
  },
  setCurrentTemplate ({commit}, data) {
    commit(types.SET_CURRENT_TEMPLATE, {data})
  },
  setDraggedTemplate ({commit}, data) {
    commit(types.SET_DRAGGED_TEMPLATE, {data})
  },
  setTemplateSetting ({commit}, data) {
    commit(types.SET_TEMPLATES_SETTINGS, {data})
  }
}
const mutations = {
  [types.SET_TEMPLATES_LIST] (state, {data}) {
    state.templatesList = data
  },
  [types.SET_FOLDERS_LIST] (state, {data}) {
    state.foldersList = data
  },
  [types.SET_CURRENT_FOLDER] (state, {data}) {
    state.currentFolder = data
  },
  [types.SET_CURRENT_TEMPLATE] (state, {data}) {
    state.currentTemplate = data
  },
  [types.SET_DRAGGED_TEMPLATE] (state, {data}) {
    state.draggedTemplate = data
  },
  [types.SET_TEMPLATES_SETTINGS] (state, {data}) {
    state.templateSetting = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/Templates/modules/store.js